import type { Severity } from '@/model/Agent.model';
import type { FC } from 'react';
import styles from './sendResults.module.scss';

const severityText: Record<Severity, string> = { error: 'Error', warning: 'Warning', info: 'Info' };

const badgeClass: Record<Severity, string> = {
  error: styles.badgeError,
  warning: styles.badgeWarning,
  info: styles.badgeInfo,
};

interface SendSeverityBadgeProps {
  severity: Severity;
  className?: string;
  testId?: string;
}

/**
 * The severity of a SEND finding as an outlined pill, coloured by severity. Shows the server's
 * severity as given; it never adds a "submission-blocking" reading of its own.
 */
const SendSeverityBadge: FC<SendSeverityBadgeProps> = ({
  severity,
  className = '',
  testId = 'send-severity-badge',
}) => (
  <span
    className={`${styles.badge} ${badgeClass[severity]} ${className}`}
    data-test-component="SendSeverityBadge"
    data-test-key={severity}
    data-testid={testId}
  >
    <span className={`${styles.severityDot} ${styles[severity]}`} aria-hidden="true" />
    {severityText[severity]}
  </span>
);

export default SendSeverityBadge;
